import React from 'react';

function CheckCircle() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path
                d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z"
                stroke="#00AC46" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M21.5 13L14.1625 20L10.5 16.5" stroke="#00AC46" strokeLinecap="round"
                strokeLinejoin="round" />
        </svg>
    );
}

function ChevronUp() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M4.5 15L12 7.5L19.5 15" stroke="#919394" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

function ChevronDown() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M19.5 9L12 16.5L4.5 9" stroke="#919394" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

function IconClipboard() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M11.25 2.8125H14.0625C14.2117 2.8125 14.3548 2.87176 14.4602 2.97725C14.5657 3.08274 14.625 3.22582 14.625 3.375V15.1875C14.625 15.3367 14.5657 15.4798 14.4602 15.5852C14.3548 15.6907 14.2117 15.75 14.0625 15.75H3.9375C3.78832 15.75 3.64524 15.6907 3.53975 15.5852C3.43426 15.4798 3.375 15.3367 3.375 15.1875V3.375C3.375 3.22582 3.43426 3.08274 3.53975 2.97725C3.64524 2.87176 3.78832 2.8125 3.9375 2.8125H6.75" stroke="#23282A" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.1875 5.0625V4.5C6.1875 3.75408 6.48382 3.03871 7.01126 2.51126C7.53871 1.98382 8.25408 1.6875 9 1.6875C9.74592 1.6875 10.4613 1.98382 10.9887 2.51126C11.5162 3.03871 11.8125 3.75408 11.8125 4.5V5.0625H6.1875Z" stroke="#23282A" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

function IconMark() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path d="M7 12.25C9.8995 12.25 12.25 9.8995 12.25 7C12.25 4.10051 9.8995 1.75 7 1.75C4.10051 1.75 1.75 4.10051 1.75 7C1.75 9.8995 4.10051 12.25 7 12.25Z" stroke="#919394" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.5625 6.5625H7V9.625H7.4375" stroke="#919394" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6.89062 5.25C7.25306 5.25 7.54688 4.95619 7.54688 4.59375C7.54688 4.23131 7.25306 3.9375 6.89062 3.9375C6.52819 3.9375 6.23438 4.23131 6.23438 4.59375C6.23438 4.95619 6.52819 5.25 6.89062 5.25Z" fill="#919394"/>
        </svg>
    )
}

function IconNext() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M6 3L11 8L6 13" stroke="#23282A" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

function IconWarning() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16 13V18" stroke="#FAD400" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M14.2748 4.99995L3.27479 24C3.09955 24.3035 3.00715 24.6477 3.00684 24.9982C3.00653 25.3487 3.09832 25.6931 3.27302 25.9969C3.44773 26.3007 3.6992 26.5533 4.00226 26.7294C4.30532 26.9054 4.64932 26.9987 4.99979 27H26.9998C27.3503 26.9987 27.6943 26.9054 27.9973 26.7294C28.3004 26.5533 28.5519 26.3007 28.7266 25.9969C28.9013 25.6931 28.9931 25.3487 28.9927 24.9982C28.9924 24.6477 28.9 24.3035 28.7248 24L17.7248 4.99995C17.5509 4.69603 17.2997 4.44346 16.9968 4.26781C16.6939 4.09215 16.35 3.99963 15.9998 3.99963C15.6496 3.99963 15.3057 4.09215 15.0028 4.26781C14.6998 4.44346 14.4487 4.69603 14.2748 4.99995V4.99995Z" stroke="#FAD400" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17 22.5C17 23.0523 16.5523 23.5 16 23.5C15.4477 23.5 15 23.0523 15 22.5C15 21.9477 15.4477 21.5 16 21.5C16.5523 21.5 17 21.9477 17 22.5Z" stroke="#FAD400"/>
        </svg>
    );
}

function IconGreenTick () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
            <path d="M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28Z" stroke="#00AC46" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21.5 13L14.1625 20L10.5 16.5" stroke="#00AC46" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

function IconClose () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
            <path d="M17.1875 4.8125L4.8125 17.1875" stroke="#23282A" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M17.1875 17.1875L4.8125 4.8125" stroke="#23282A" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

function IconTriangle (className) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="16" viewBox="0 0 8 16" fill="none">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.41421 9.41421C0.633164 8.63316 0.633165 7.36684 1.41421 6.58579L8 0V16L1.41421 9.41421Z" fill="#F3F5F3"/>
        </svg>
    )
}

export { CheckCircle, ChevronUp, ChevronDown, IconClipboard, IconMark, IconNext, IconWarning, IconClose, IconTriangle }
